import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface MethodDetails {
  id: string;
  [key: string]: any;
}

export interface BulkMethodsResponse {
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryMethodApi = createApi({
  reducerPath: "registryMethodApi",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryMethod", "Methods"],
  endpoints: (build) => ({
    getRegistryMethodDetails: build.query<MethodDetails, string>({
      query: (id) => `/rs/registry/method/${id}`,
      providesTags: ["RegistryMethod"],
    }),
    getRegistryBulkMethods: build.query<BulkMethodsResponse, string[]>({
      query: (ids) => ({
        url: "/rs/registry/bulkmethods",
        params: { ids: ids.join(",") },
      }),
      providesTags: ["Methods"],
    }),
  }),
});

export const {
  useGetRegistryMethodDetailsQuery,
  useGetRegistryBulkMethodsQuery,
} = registryMethodApi;
